import {
  takeEvery, call, put, fork
} from 'redux-saga/effects';
import { loadIsler, saveIsler } from 'src/utils/storage/WorkOrder';
import { setIslerAdet, setClosedJobCount } from 'src/utils/storage/NavBarAdet';
import * as actions from '../actions/taskActions';
import * as api from '../api/tasks';
import { combineDateTime, getUser } from 'src/utils/Common';

function* getTasks() {
  try {
    saveIsler([]);
    setIslerAdet(0);
    setClosedJobCount(0);
    let result = '';
    if (window.navigator.onLine) {
      result = yield call(api.getTasks);

      const closedJobs = (result.data != undefined && result.data !== '') ? result.data.filter(f => f.IsOpen === 0) : [];
      const openJobs = (result.data != undefined && result.data !== '') ? result.data.filter(f => f.IsOpen === 1) : [];

      const sessionUser = getUser();

      if (sessionUser.TenantId === 16) {
        //UK SPESIFIC API CALLING
        let toaResourceActivities = yield call(api.GetToaResourceActivities);

        if (result.data != null && result.data.length > 0) {
          const toaWorkOrderDetails = toaResourceActivities.data.map(toaResourceActivity => ({
            workOrderId: parseInt(toaResourceActivity.WorkOrderId, 10),
            positionInRoute: toaResourceActivity.PositionInRoute,
            deliveryWindowStart: toaResourceActivity.DeliveryWindowStart,
            deliveryWindowEnd: toaResourceActivity.DeliveryWindowEnd,
            deliveryDate: toaResourceActivity.DeliveryDate
          }));

          const orderableJobs = result.data.filter(openJob => {
            const match = toaWorkOrderDetails.find(item => item.workOrderId === openJob.ReceiptNo);
            if (match) {
              console.log(match);
              openJob.PositionInRoute = match.positionInRoute;
              openJob.AppointmentBegin = combineDateTime(match.deliveryDate, match.deliveryWindowStart);
              openJob.AppointmentEnd = combineDateTime(match.deliveryDate, match.deliveryWindowEnd);
              return true;
            }
            return false;
          });


          if (orderableJobs.length > 0) {

            let orderedJobs = orderableJobs.sort((a, b) => a.PositionInRoute - b.PositionInRoute);

            saveIsler(orderedJobs);
            setIslerAdet(openJobs.length);
            setClosedJobCount(closedJobs.length);
            yield put(actions.getTasksSuccess(orderedJobs));
            return;
          }
        }


      }

      saveIsler(result.data);
      setIslerAdet(openJobs.length);
      setClosedJobCount(closedJobs.length);
      yield put(actions.getTasksSuccess(result.data));
    } else {
      result = loadIsler();
      setIslerAdet(result.length);
      yield put(actions.getTasksSuccess(result));
    }
  } catch (error) {
    console.error("API failed, loading from localStorage", error);
  
    const resultError = loadIsler();

    if (resultError && resultError.length > 0) {
      setIslerAdet(resultError.filter(f => f?.IsOpen === 1).length);
      setClosedJobCount(resultError.filter(f => f?.IsOpen === 0).length);
      yield put(actions.getTasksSuccess(resultError));
    } else {
      setIslerAdet(0);
      setClosedJobCount(0);
      yield put(actions.getTasksSuccess([]));
    }
  }
}

function* watchGetTaskRequest() {
  yield takeEvery(actions.Types.GET_TASK_REQUEST, getTasks);
}


function* setWorkOrderToCacheRequest(WorkOrderId, Payload) {
  try {
    const result = yield call(api.SetWorkOrderToCache, WorkOrderId, Payload);
  }
  catch { }
}


function* watchSetWorkOrderToCacheRequest() {
  yield takeEvery(actions.Types.SET_WORKORDER_TO_CACHE, setWorkOrderToCacheRequest);
}

const taskSagas = [fork(watchGetTaskRequest), fork(watchSetWorkOrderToCacheRequest)];

export default taskSagas;
